<ng-container>
    <app-segment
        *ngFor="let flight of product.flights; let i = index"
        [index] = "i"
        [flight]="flight">
    </app-segment>
    <app-info [info]="product.info" [price]="product.price"></app-info>
</ng-container>